"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Status_1 = __importDefault(require("./Status/Status"));
var Column_1 = __importDefault(require("./Column/Column"));
var ActionBar_1 = __importDefault(require("./ActionBar/ActionBar"));
var HeaderBar_1 = __importDefault(require("./HeaderBar/HeaderBar"));
var Pagination_1 = __importDefault(require("./Pagination/Pagination"));
var translations_1 = __importDefault(require("./translations"));
var DataTableRender_1 = __importDefault(require("./DataTableRender"));
var localization_1 = require("@scuf/localization");
/**
 * @child ./Column/Column.tsx
 * @child ./Status/Status.tsx
 * @child ./ActionBar/ActionBar.tsx
 * @child ./HeaderBar/HeaderBar.tsx
 * @child ./Pagination/Pagination.tsx
 */
var DataTable = /** @class */ (function (_super) {
    __extends(DataTable, _super);
    function DataTable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataTable.prototype.render = function () {
        return React.createElement(localization_1.LocalizationProvider, { translations: translations_1.default },
            React.createElement(DataTableRender_1.default, __assign({}, this.props)));
    };
    DataTable.defaultProps = {
        columnResizeMode: 'fit',
        reorderableColumns: false,
        scrollable: false,
        showHeader: true
    };
    DataTable.Column = Column_1.default;
    DataTable.Status = Status_1.default;
    DataTable.ActionBar = ActionBar_1.default;
    DataTable.HeaderBar = HeaderBar_1.default;
    DataTable.Pagination = Pagination_1.default;
    return DataTable;
}(React.Component));
exports.default = DataTable;
//# sourceMappingURL=DataTable.js.map